import { useEffect, useState } from 'react';
import { api, Dashboard } from '../api/client';
import { DashboardCard, SkeletonCard, ViewToggle, useViewMode } from '../components/Layout';

export default function HomePage() {
  const [dashboards, setDashboards] = useState<Dashboard[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [viewMode, toggleViewMode] = useViewMode();

  useEffect(() => {
    api.listDashboards()
      .then((r) => setDashboards(r.dashboards ?? []))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const prototypes = dashboards.filter((d) => d.uploadType === 'prototype');
  const uploadedDashboards = dashboards.filter((d) => d.uploadType !== 'prototype');
  const hasDashboards = uploadedDashboards.length > 0;
  const gridClass = viewMode === 'list' ? 'canvas-list' : 'grid';

  return (
    <div>
      <div className="page-header">
        <h1>My Uploads</h1>
        <div className="page-header-actions">
          <ViewToggle mode={viewMode} onToggle={toggleViewMode} />
          <a href="/new" className="btn success">New Upload</a>
        </div>
      </div>
      {error && <p className="error">{error}</p>}

      {loading && (
        <div className={gridClass}>
          {Array.from({ length: 6 }, (_, i) => <SkeletonCard key={i} viewMode={viewMode} />)}
        </div>
      )}

      {!loading && !dashboards.length && !error && (
        <p className="muted">No canvases yet. Create your first one.</p>
      )}

      {!loading && prototypes.length > 0 && (
        <section className="upload-section">
          <h2 className="upload-section-title">Prototypes</h2>
          <div className={gridClass}>
            {prototypes.map((d) => <DashboardCard key={d.dashboardId} dashboard={d} viewMode={viewMode} />)}
          </div>
        </section>
      )}

      {!loading && hasDashboards && (
        <section className="upload-section">
          {uploadedDashboards.length > 0 && (
            <section className="upload-subsection">
              <h3 className="upload-subsection-title">Uploaded</h3>
              <div className={gridClass}>
                {uploadedDashboards.map((d) => <DashboardCard key={d.dashboardId} dashboard={d} viewMode={viewMode} />)}
              </div>
            </section>
          )}
        </section>
      )}
    </div>
  );
}
